import React from 'react';

const LeftArrow = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="11"
    viewBox="0 0 7 11"
    className={className}
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M6 10a.5.5 0 0 1-.706.037L.253 5.5 5.293.963a.5.5 0 1 1 .669.743L1.748 5.5l4.216 3.794A.5.5 0 0 1 6 10z"
    />
  </svg>
);

export default LeftArrow;
